import { Routes, RouterModule } from '@angular/router';

const expOrgRoutes: Routes = [
];

export const ExpOrgExtRouter = RouterModule.forChild(expOrgRoutes);